import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function DownloadButton({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled: boolean;
}) {
  return (
    <button
      type="button"
      aria-label="Baixar imagens"
      className="tf-pnt-mobile-download-button"
      onClick={onClick}
      disabled={disabled}
    >
      <Icon iconType="download" color={cssVar(disabled ? 'text-disabled' : 'text-strong')} size="small" />
    </button>
  );
}
